<script setup>
  import { useLocale } from 'vuetify'
  const { t } = useLocale()
</script>
<template>
    <div class="w-100">
        <v-text-field
            name="dates-range"
            id="formattedDates"
            role="dates-range"
            type="text"
            aria-label="dates-range"
            title="dates-range"
            :hide-details="hideDetails"
            :rules="requiredRules"
            v-model="formattedDates"
            variant="solo-filled"
            readonly
            clearable
            @click:clear="reset"
            class="bg-search font-weight-bold"
            :label="label"
        >
        <v-menu 
            v-model="menu"
            activator="parent"
            class="w-100 d-block"
            :close-on-content-click="false"
        >   

            <v-card rounded="0" class="w-100" >
                <v-card-title class="bg-primary">
                    <h4>{{ label }}
                        <v-btn v-if="startDay && endDay" color="white" variant="outlined" size="small" class="float-end " @click="update(true)" >{{ t('commons.dates-confirm') }}</v-btn>
                    </h4>
                    <p>
                        <!-- <v-btn v-if="formattedDates" color="black" variant="plain" width="25" height="25" @click="reset" icon="mdi-close-circle"></v-btn> -->
                        {{ formattedDates ?? t('commons.select-detetime') }}
                        <!-- <v-btn v-if="startDay && endDay" color="black" variant="text" size="x-small" class="float-end" @click="reset" icon="mdi-close-circle"></v-btn> -->
                    </p>
                    
                </v-card-title>
                <v-alert rounded="0" closable v-if="diff > 15 && diff < 30" size="small" color="info">
                    Testo di desscrizione per periodo superiore a 15gg {{ t('commons.rent-over15days-alert') }}
                    <br>
                    <v-btn color="white" variant="outlined" size="x-small">richiedi una quotazione personalizzata per il breve termine</v-btn>
                </v-alert>
                <v-alert rounded="0" closable v-if="diff > 30" size="small" color="error" >
                    Testo di desscrizione per periodo superiore a 39 {{ t('commons.rent-over30days-alert') }}
                    <br>
                    <v-btn color="white" variant="outlined" size="x-small">richiedi una quotazione personalizzata per il medio termine</v-btn>
                </v-alert>    
                <v-divider></v-divider>
                
                        <v-date-picker
                        width="100%"
                        multiple
                        view-mode="month"
                        return-object
                        rounded="0"
                        hide-header
                        @update:month="addClassInSelected"
                        :title="label"
                        role="dialog"
                        :max="max"
                        :min="min"
                        v-model="localModel" 
                        @update:model-value="updateDate"
                        color="primary"
                        show-adjacent-months>
                        </v-date-picker>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row>
                        <v-col cols="6">
                            <v-select
                                chips
                                hide-details
                                v-model="startHour"
                                :label="t('attributes.time-start.label')"
                                :items="validStartHours"
                                item-title="text"
                                item-value="value"
                                variant="outlined"
                            ></v-select>
                        </v-col>
                        <v-col cols="6">
                            <v-select
                                chips
                                hide-details
                                v-model="endHour"
                                :label="t('attributes.time-end.label')"
                                :items="validEndHours"
                                item-title="text"
                                item-value="value"
                                variant="outlined"
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- <v-divider></v-divider>
                <v-card-actions>
                    <v-btn block size="small" variant="outlined" :href="t('commons.rent-over30days-link')"> {{ t('commons.rent-over30days-button') }} </v-btn>
                </v-card-actions> -->
            </v-card>
        </v-menu>
        </v-text-field>
    </div>
</template>


<script>

export default {
    props:{
        label:{
            type: String,
            required: false,
            default: "date range"
        },
        focus:{
            type: Boolean,
            required: false,
            default: false
        },
        preValue:{
            type: Object,
            required: false,
        },
        hideDetails:{
            type: Boolean,
            default: true,
        }
    },
    data: () => ({
        requiredRules: [
            value => !!value || 'attributes.generic.validation.required',
        ],
        localModel: [],
        startDay: null,
        startHour: null,
        validStartHours: [],
        validEndHours: [],
        endDay: null,
        endHour: null,
        formattedDates: null,
        menu: false,
        min: null,
        max: null,
        diff: null,
    }),
    mounted(){
        this.menu = false;
        if(this.focus){
            this.menu = true;
        }

        this.validEndHours = this.generateHoursArray()
        this.validStartHours = this.generateHoursArray()

        this.min = this.$moment().add(0,'days').format('YYYY-MM-DD');
        this.max = this.$moment().add(1,'year').format('YYYY-MM-DD');

        if(this.preValue.start.date && this.preValue.end.date){
            this.startDay  = this.$moment(this.preValue.start.date)
            this.endDay  = this.$moment(this.preValue.end.date)

            this.startHour = parseInt(this.$moment(this.preValue.start.date).format('HH'));
            this.endHour = parseInt(this.$moment(this.preValue.end.date).format('HH'));

            this.updateDate([this.startDay, this.endDay]);
            this.diff = this.endDay.diff(this.startDay,'days');

        }else{
            this.startHour = 10
            this.endHour = 10
        }

    },
    watch:{
        menu:{
            handler: function(menu) {
                if(!menu){
                    if(!this.startDay || !this.endDay){
                        //alert("Please select a range of days");
                        this.menu = true;
                    }
                }

                this.addClassInSelected();

            }
        },
        localModel:{
            handler: function(localModel, oldlocalModel) {

                this.addClassInSelected()

                if(oldlocalModel.length > 2){
                    // se era già selezionato il range puliscilo, così da poter riselezionare un range completo.
                    this.reset();
                    return false;
                }

                if(localModel.length >= 1){
            
                    if(this.$moment(localModel[0]).format('YYYY-MM-DD') == this.$moment().format('YYYY-MM-DD')){
                        this.startHour = parseInt(this.$moment().startOf('hour').add(4,'hours').format('HH'));
                    }

                    this.startDay = this.$moment(localModel[0]).startOf('day').add(this.startHour, 'hours');
                    
                    if(localModel[0] == localModel[localModel.length - 1]){
                            this.endDay = null;
                    }else{
                        this.endDay = this.$moment(localModel[localModel.length - 1]).startOf('day').add(this.endHour, 'hours');
                    }

                    if(localModel.length >= 2){
                            this.update();
                            // this.menu = false;
                    }
                }else{
                    this.startDay = null;
                    this.endDay = null;
                    this.formattedDates = null;
                }

            },
            deep: true
        },
        startDay:{
            handler: function(startDay) {
                if(startDay ){
                    this.max = this.$moment(startDay).add(1,'year').format('YYYY-MM-DD');
                    this.formattedDates = startDay.format("D MMM HH:mm")+ ' - ';
                    if(this.endDay){
                        this.diff = this.endDay.diff(this.startDay,'days');
                        this.formattedDates = startDay.format("D MMM HH:mm")+' - '+this.endDay.format("D MMM HH:mm");
                    }
                }else{
                    this.diff = null;
                    this.formattedDates = null;
                }

                // if(startDay){
                //     // reset the min and max
                //     // set min as the start day to able selection only in the future
                //     // this.min = this.$moment(startDay).format('YYYY-MM-DD');
                //     // dont allow to select more than 30 days
                //     console.log("startDay",startDay);
                //     // this.max = this.$moment(startDay).add(31,'days').format('YYYY-MM-DD');
                // }else{
                //     // reset the min and max
                //     // this.min = this.$moment().add(0,'days').format('YYYY-MM-DD');
                //     // this.max = this.$moment().add(1,'year').format('YYYY-MM-DD');
                   
                // }
                // console.log("New MAX", this.max);
                // console.log("New MIN", this.min);
            },
            deep: true
        },
        endDay:{
            handler: function(endDay) {
                if(this.startDay && endDay){
                    this.diff = this.endDay.diff(this.startDay,'days');
                    this.formattedDates = this.startDay.format("D MMM HH:mm")+' - '+endDay.format("D MMM HH:mm");
                }
            },
            deep: true
        },
        startHour:{
            handler: function(startHour) {
                if(this.startDay){
                    this.startDay = this.$moment(this.startDay).startOf('day').add(startHour,'hours');
                    this.update(false);
                }
            }
        },
        endHour:{
            handler: function(endHour) {
                if(this.endDay){
                    this.endDay = this.$moment(this.endDay).startOf('day').add(endHour,'hours');
                    this.update(false);
                }
            }
        }
    },
    methods:{
        reset(){
            this.localModel = [];
            this.startDay = null;
            this.endDay = null;
            this.diff = null;
            this.formattedDates = null;
            this.min = this.$moment().add(0,'days').format('YYYY-MM-DD');
            this.max = this.$moment().add(1,'year').format('YYYY-MM-DD');
        },
        async addClassInSelected(){
            await this.$nextTick();
            var selectedDays = document.querySelectorAll('.v-date-picker-month__day--selected');
            // console.log('selectedDays',selectedDays)
            if(selectedDays.length > 0){
                selectedDays[0].classList.add('first-day-selected');
                selectedDays[selectedDays.length - 1].classList.add('last-day-selected');
            }
            
        },
        updateDate(val){

            if(val.length > 1){
                val = val.sort((a, b) => new Date(a) - new Date(b));
                this.localModel = this.dateInRange(val[0], val[val.length - 1])
            }

            
        },
        dateInRange(startDate, endDate) {
            const datesArray = [];
            let currentDate = new Date(startDate);

            while (currentDate <= endDate) {
                datesArray.push(new Date(currentDate));
                currentDate.setDate(currentDate.getDate() + 1);
            }

            return datesArray;
        },
        update(autoclose=null){

               

                if(this.startDay && this.endDay){
                    this.diff = this.endDay.diff(this.startDay,'days');

                    if(this.diff <= 15){
                        autoclose = true;
                    }else{
                        if(!autoclose){
                            autoclose = false;
                        }
                    }
                    
                        let dates = {
                            startDate: this.startDay.format(),
                            endDate: this.endDay.format(),
                        }
                        if(autoclose){
                            this.menu = false;
                        }
                        this.$emit('update', dates)
                        
                    
                    
                }

                
        },
        generateHoursArray() {
            const hoursArray = [];

            for (let i = 0; i <= 24; i++) {
                const hourText = (i < 10 ? '0' : '') + i + ":00";
                hoursArray.push({ text: hourText, value: i });
            }

            return hoursArray;
        }
    }
}

</script>

<style>

.v-date-picker-month__day--selected{
    background-color: rgba(var(--v-theme-primary), 0.3) !important;
}
.first-day-selected {
    border-left: 3px solid rgb(var(--v-theme-primary)) !important;
}
.last-day-selected {
    border-right: 3px solid rgb(var(--v-theme-primary)) !important;
}


</style>